import Sidebar from '@components/sidebar';
import { Col, ListGroup, ListGroupItem, Row } from 'reactstrap';

const EpisodesSidebar = ({ open, toggleSidebar, data }) => {
  const handleSidebarClosed = () => {};

  return (
    <Sidebar
      size="lg"
      open={open}
      title={'Visualización de Episodios'}
      headerClassName="mb-1"
      contentClassName="pt-0"
      toggleSidebar={toggleSidebar}
      onClosed={handleSidebarClosed}
    >
      <ListGroup numbered="true">
        {data.map((item, idx) => (
          <ListGroupItem key={item._id}>
            <Row>
              <Col
                style={{
                  display: 'flex',
                  alignSelf: 'center',
                  justifySelf: 'center'
                }}
                md={1}
              >
                {idx + 1}
              </Col>
              <Col md={2}>
                <img src={item.cover} width={50} height={50} />
              </Col>
              <Col>{item.title}</Col>
            </Row>
          </ListGroupItem>
        ))}
      </ListGroup>
    </Sidebar>
  );
};

export default EpisodesSidebar;
